import { createSlice } from "@reduxjs/toolkit";

const moughataaSlice = createSlice({
  name: "moughataas",
  initialState: {
    isFetching: false,
    moughataas: [],
    error: []
  },
  reducers: {
    statusMoughataaStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusMoughataaSuccess: (state, action) => {
      state.isFetching = false
      state.moughataas = action.payload
      state.error = []
    },
    statusMoughataaFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusMoughataaStart,
  statusMoughataaSuccess,
  statusMoughataaFailure 
} = moughataaSlice.actions

export default moughataaSlice.reducer